import React from 'react';
import { useFeatureCreditEstimate } from '../../http-hooks/organisation/useFeatureCreditEstimate';

// Small inline "this will cost N credits" label for the AI-audio feature dialogs (dubbing,
// voice changer/isolation/design/clone/mix). Renders nothing until real rates are configured
// (credits === 0), so it stays invisible during the placeholder-pricing phase and appears
// automatically once rates are set. Turns red when the balance can't cover the cost.
export default function FeatureCreditCost({
    orgId,
    feature,
    durationSeconds = null,
    enabled = true,
    className = '',
    style = {},
}) {
    const { data } = useFeatureCreditEstimate({
        org_id: orgId,
        feature,
        duration_seconds: durationSeconds,
        enabled: enabled && !!orgId,
    });

    const credits = data?.credits;
    if (!credits || credits <= 0) return null;

    const insufficient = data?.can_create === false;

    return (
        <span
            className={className}
            style={{
                fontSize: 12,
                color: insufficient ? 'var(--bs-danger, #DC2626)' : '#94A3B8',
                whiteSpace: 'nowrap',
                ...style,
            }}
        >
            Uses ~{credits.toLocaleString()} credit{credits === 1 ? '' : 's'}
            {insufficient ? ' · not enough credits' : ''}
        </span>
    );
}
